import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { clog } from "../lib/utils";

function ZohoCallBackUrl() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(true);
  const getZohoAccessToken = async (code, status_code, error_message) => {
    // clog(id);
    // let zoho_access = JSON.parse(localStorage.getItem("zoho_access") || "false");
    // if(zoho_access){
    //   let navigation= "/integration-sales";
    //     setTimeout(() => {
    //       navigate(navigation);
    //     }, 100);
    //     return
    // }
    setloading(true);
    try {
      const response = await axios({
        // url: `${
        //   process.env.REACT_APP_BASE_SIGNIN_URL
        // }/slack/callback?code=${code}&state=${state}&user_id=${
        //   JSON.parse(localStorage.getItem("login_data"))?.resp_user?.id
        // }`,
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/zoho/api/auth/zoho/callback`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          code: code,
          status_code: status_code,
          error_message: error_message,
        },
      });
      if (!response.data.error) {
        // window.open(response.data.url, "_self");
        localStorage.setItem(
          "zoho_access",
          JSON.stringify(response.data?.data)
        );
        let navigation = "/integration-sales";
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      } else {
        localStorage.setItem("zoho_access", JSON.stringify(false));
        let navigation = `/integration-sales?error=${response.data.message}`;
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get("code");
    let status_code = searchParams.get("status_code");
    let error = searchParams.get("error");
    let zoho_access = JSON.parse(
      localStorage.getItem("zoho_access") || "false"
    );
    if (code && !error) {
      getZohoAccessToken(code, status_code, error);
    } else {
      setloading(false);
      localStorage.setItem("zoho_access", JSON.stringify(false));
      let navigation = `/integration-sales?error=${error}`;
      setTimeout(() => {
        navigate(navigation);
      }, 100);
    }
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      {loading && <Loader />}
    </div>
  );
}

export default ZohoCallBackUrl;
